<template>
  <div class="row">
    <div class="col-12">
      <card>
        <el-collapse v-model="activeName" @change="handleCollapse">
          <el-collapse-item :title="titleFilter" name="filter">
            <filter-component
              :isRequiredFarms="true"
              :isMultipleFarms="false"
              @filter="handleFilter"
              @showHideLoading="showHideLoading"
              classFarms="col-12 col-sm-6 col-md-6 col-lg-4 col-xl"
              classLots="col-12 col-sm-6 col-md-6 col-lg-4 col-xl"
            >
              <template slot="prev">
                <div class="col-12 col-sm-12 col-md-6 col-lg-4 col-xl-4 pt-3">
                  <label for="">{{ $t('common_words.evaluations') }}: * </label>
                  <br />
                  <el-select
                    clearable
                    collapse-tags
                    style="width: 100%"
                    filterable
                    class="select-primary custom-width-select shadow-sm required-evaluation_id"
                    v-model="evaluation_id"
                    :placeholder="`${$t('common_words.select')}...`"
                  >
                    <el-option
                      class="select-primary"
                      v-for="item in evaluations"
                      :key="item.id + item.name"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </div>
              </template> </filter-component
          ></el-collapse-item>
        </el-collapse>
      </card>
    </div>
    <div class="col-12">
      <div v-if="haveData">
        <Legend></Legend>
        <card>
          <el-container>
            <aside-list
              addClass="col-text-ellipsis"
              @clickItem="loadData"
              :label="$t('common_words.indicators')"
              :list="indicators"
            />
            <el-container>
              <el-main>
                <div class="row">
                  <div class="col-12">
                    <highcharts :options="actualChart"></highcharts>
                  </div>
                </div>
              </el-main>
            </el-container>
          </el-container>
        </card>
        <card>
          <div class="custom-scroll-table-wrapper">
            <table class="table table-striped table-bordered mt-3 mb-5">
              <thead>
                <tr class="cusmtom-thead-color">
                  <th
                    scope="col"
                    class="text-center p-3 custom-header-label sticky-header"
                  >
                    {{ $t('common_words.tasks') }}
                  </th>
                  <th
                    scope="col"
                    class="text-center p-3 custom-header-label sticky-header"
                    v-for="(farm, index) in tableData.farm"
                    :key="index"
                  >
                    {{ farm.lot_name ? farm.lot_name : farm.farm_name }}
                  </th>

                  <!-- <th
                    v-if="evaluationWithLots"
                    scope="col"
                    class="text-center p-3 custom-header-label sticky-header"
                  >
                    {{ $t('common_words.total') }}
                  </th> -->
                  <th
                    v-if="
                      evaluationWithLots &&
                      (haveMoreOneEvaluations || haveMoreQuantityEvaluations)
                    "
                    scope="col"
                    class="text-center p-3 custom-header-label sticky-header"
                  >
                    {{ $t('common_words.total') }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(task_names, index2) in tableData.task_names"
                  :key="'row-' + index2"
                  :class="{
                    'bg-total-row': index2 === tableData.task_names.length - 1,
                  }"
                >
                  <td>{{ task_names }}</td>
                  <td
                    v-for="(farm, index3) in tableData.farm"
                    :key="'cell-' + index2 + '-' + index3"
                    class="text-center p-3"
                    :style="getBorderColorByCompliance(farm.tasks, task_names)"
                  >
                    {{
                      getCompliancePercentageByColumn(farm.tasks, task_names)
                    }}
                  </td>
                  <!-- ESTA COLUMNA SERA OCULTADA MOMENTANEAMENTE PORQUE ES LA COLUMNA
                  QUE SE LE MOSTRARA AL CLIENTE QUE NO NECESITE VER EL % DE CUMPLIMIENTO
                  POR EL HECTAREAJE DEL LOTE -->
                  <!-- <td
                    v-if="evaluationWithLots"
                    class="text-center p-3"
                    :style="getBorderColorComplianceByTotalColumn(index2)"
                  >
                    {{ getCompliancePercentageByTotalColumn(index2) }}
                  </td> -->
                  <!-- COLUMNA DE % DE CUMPLIMIENTO TENIENDO EN CUENTA EL HECTAREAJE DEL LOTE -->
                  <td
                    v-if="
                      evaluationWithLots &&
                      (haveMoreOneEvaluations || haveMoreQuantityEvaluations)
                    "
                    class="text-center p-3"
                    :style="getBorderColorComplianceByTotalColumn(index2)"
                  >
                    {{ getCompliancePercentageByTotalColumnByLotArea(index2) }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { Chart } from 'highcharts-vue';
import { isset } from 'src/util/Util';
import AsideList from 'src/components/Layouts/AsideList.vue';
import Filter from 'src/components/Filter/Filters.vue';
import i18n from 'src/i18n';
import Legend from 'src/views/Pages/Dashboard/AdvancedAudit/Components/Legend.vue';
import mixinCharts from 'src/util/mixinCharts';
import MixinForm from 'src/mixins/forms/mixin-form';
import MixinMasters from 'src/util/mixinMasters';
import MixinMenu from 'src/util/mixinMenu';
import MixinPermissions from 'src/util/mixinPermissions';
import SweetAlert from 'src/class/Alerts';

export default {
  components: {
    [AsideList.name]: AsideList,
    [Filter.name]: Filter,
    highcharts: Chart,
    Legend,
  },
  computed: {
    titleFilter() {
      if (this.valueCollapse) {
        return this.valueCollapse.length === 1
          ? this.$i18n.t('uti.mixinFilter.hideFilters')
          : this.$i18n.t('uti.mixinFilter.showFilters');
      }

      return this.$i18n.t('uti.mixinFilter.hideFilters');
    },
    indicators() {
      return [
        { id: 0, name: i18n.t('common_words.bar_chart') },
        { id: 1, name: i18n.t('common_words.line_chart') },
      ];
    },
  },
  data() {
    return {
      valueCollapse: null,
      activeName: 'filter',
      activeFarm: [],
      evaluations: [],
      evaluation_id: null,
      model: {},
      tableData: [],
      chartOptions: {},
      actualChart: [],
      haveData: false,
      evaluationWithLots: false,
      haveMoreOneEvaluations: false,
      haveMoreQuantityEvaluations: false,
    };
  },
  mixins: [mixinCharts, MixinMasters, MixinPermissions, MixinMenu, MixinForm],
  methods: {
    handleFilter(data) {
      this.dataFilter = { ...data };
      this.activeFarm = [];
      this.getData();
    },
    handleCollapse(val) {
      this.valueCollapse = val;
    },
    getData() {
      if (!isset(this.evaluation_id)) {
        return this.validationInputsRequired('evaluation_id');
      }
      this.haveData = false;
      this.evaluationWithLots = false;
      this.haveMoreOneEvaluations = false;
      this.haveMoreQuantityEvaluations = false;
      this.showHideLoading(true);
      let data = this.dataFilter;

      if (data.bySel === 'Año') {
        data.datei += '-01-01';
        data.datef += '-12-31';
      }
      data.evaluation_id = this.evaluation_id;
      data.route = 'advanced/audits/matrixreport';
      Axios.postMasters(data)
        .then((response) => {
          this.tableData = response.data.data;
          if (this.tableData.length == 0) {
            SweetAlert.warning(i18n.t('common_words.unavailable_data'));
          } else {
            this.haveData = true;
            try {
              this.chartOptions[0] = this.columns(
                this.tableData.column_chart,
                true
              );
              this.chartOptions[1] = this.lines(
                this.tableData.line_chart,
                true,
                'auto',
                false,
                true
              );
              this.actualChart = this.chartOptions[0];
            } catch (error) {}
          }
          const lotId = this.tableData.farm[0].lot_id;
          const haveMoreEvaluations =
            this.tableData.farm[0].tasks[0].total_tasks;
          if (isset(lotId)) {
            this.evaluationWithLots = true;
            if (haveMoreEvaluations > 1) this.haveMoreOneEvaluations = true;
            this.haveMoreQuantityEvaluations = this.getQuantityEvaluations(
              this.tableData.farm
            );
          }
          this.showHideLoading();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    },
    loadData(data) {
      this.actualChart = {};
      setTimeout(() => {
        this.actualChart = { ...this.chartOptions[data.id] };
      }, 0.1);
    },
    getCompliancePercentageByColumn(tasks, taskName) {
      const label = i18n.t('common_words.total');
      if (taskName === label) {
        const totalRow = tasks.find((t) => t.total === label);

        return totalRow
          ? parseFloat(totalRow.total_compliance).toFixed(2) + '%'
          : '-';
      }

      const task = tasks.find((t) => t.task_name === taskName);

      return task ? parseFloat(task.total_compliance).toFixed(2) + '%' : '-';
    },
    getCompliancePercentageByTotalColumn(index2) {
      const data = this.tableData.average_by_task[index2].average_compliance;

      return data ? data + '%' : 0 + '%';
    },
    getCompliancePercentageByTotalColumnByLotArea(index2) {
      const data = this.tableData.average_by_lot_area[index2].avarage;

      return data ? data + '%' : 0 + '%';
    },
    getBorderColorComplianceByTotalColumn(index2) {
      const colorBorder = this.tableData.average_by_task[index2].border_color;

      return colorBorder ? colorBorder : '';
    },
    getBorderColorByCompliance(tasks, taskName) {
      const label = i18n.t('common_words.total');
      if (taskName === label) {
        const totalRow = tasks.find((t) => t.total === label);

        return totalRow.border_color ? totalRow.border_color : '';
      }

      const task = tasks.find((t) => t.task_name === taskName);
      if (isset(task)) return task.border_color ? task.border_color : '';
    },
    getQuantityEvaluations(evaluations) {
      if (evaluations.length > 1) return true;

      return false;
    },
  },
  created() {
    if (this.isIndex()) {
      Axios.getMasters('advanced/audits/inspections').then(
        (responseEvalluations) =>
          (this.evaluations = responseEvalluations.data.data)
      );
    } else {
      this.showHideLoading();
    }
  },
  mounted() {
    this.selectedItemOnMenu('advanced');
  },

  destroyed() {
    this.deselectedItemOnMenu('advanced');
  },
};
</script>
<style scoped>
.custom-scroll-table-wrapper {
  max-height: 600px;
  overflow: auto;
}
.sticky-header {
  position: sticky;
  top: 0;
  z-index: 3;
  background: #898989;
}
.custom-scroll-table-wrapper table {
  min-width: 700px;
  border-collapse: collapse;
}
.bg-total-row {
  background-color: #898989 !important;
  color: white !important;
}
.bg-total-row td {
  font-weight: bold !important;
}
</style>
